import React from 'react';
import PropTypes from 'prop-types';

export default function MTestimonial({ text, name }) {
	return (
		<article className="m-user-card">
			<p className="font-size-lg">{text}</p>
			<p className="author">- {name} -</p>
		</article>
	);
}

MTestimonial.propTypes = {
	text: PropTypes.string.isRequired,
	name: PropTypes.string.isRequired,
};




// WEBPACK FOOTER //
// ./src/components/molecules/_molecules.testimonial.js